import { createStore } from "vuex";

const blogStore = createStore({
  state: {
    blogTitles: [
      "Getting Score V1-ed",
      "osu!mania foo.bar",
      "osu! LN Release Strain Hot Fix",
      "Laplace for Circuits",
      "osu! Reference BPM Exploit",
      "SM Snapping",
      "Voltage Model",
    ].reverse(),
  },
  mutations: {},
  actions: {},
  modules: {},
});

export default blogStore;
